import {Component, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomMessageService, OriginMessageError} from "library";

@Component({
  selector: 'app-sales-additional-information-field-addres-colombia',
  templateUrl: './sales-additional-information-field-address-colombia.component.html',
})
export class SalesAdditionalInformationFieldAddresColombiaComponent implements OnInit{
  @Input() field: any;
  @Input() form!: FormGroup;
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);
  roadTypeOptions: any[] = []

  private readonly customMessageService  = inject(CustomMessageService);

  ngOnInit() {
    this.roadTypeOptions = this.field?.options?.road_type?.map((r: any) => ({
      label: r,
      value: r
    })) || [];
    this.form.addControl('road_type', new FormControl('', [Validators.required]))
    this.form.addControl('road_number', new FormControl(null, [Validators.required]))
    this.form.addControl('road_lyric', new FormControl('',))
    this.form.addControl('cruce_number', new FormControl(null, [Validators.required]))
    this.form.addControl('cruce_lyric', new FormControl('', ))
    this.form.addControl('cruce_number_sub', new FormControl(null, [Validators.required]))
    this.form.addControl('cruce_lyric_sub', new FormControl('', ))
    this.form.addControl('cruce_complement', new FormControl('',))

    this.patchForm()
  }

  onGenerateDataToSave(){
    this.isSubmitted.set(true);
    const road_type = this.form.get('road_type')?.value;
    const road_number = this.form.get('road_number')?.value;
    const road_lyric = this.form.get('road_lyric')?.value;
    const cruce_number = this.form.get('cruce_number')?.value;
    const cruce_lyric = this.form.get('cruce_lyric')?.value;
    const cruce_number_sub = this.form.get('cruce_number_sub')?.value;
    const cruce_lyric_sub = this.form.get('cruce_lyric_sub')?.value;
    const cruce_complement = this.form.get('cruce_complement')?.value;
    const values = {
      road_type,
      road_number,
      road_lyric,
      cruce_number,
      cruce_lyric,
      cruce_number_sub,
      cruce_lyric_sub,
      cruce_complement
    }

    this.emitSaveData(values);

  }

  private emitSaveData(values: any) {
    const data = {
      id: this.field.id,
      value: JSON.stringify({
        road_type: values.road_type,
        road_number: values.road_number,
        road_lyric: values.road_lyric ? values.road_lyric : null,
        cruce_number: values.cruce_number,
        cruce_lyric: values.cruce_lyric ? values.cruce_lyric : null,
        cruce_number_sub: values.cruce_number_sub,
        cruce_lyric_sub: values.cruce_lyric_sub ? values.cruce_lyric_sub : null,
        cruce_complement: values.cruce_complement ? values.cruce_complement : null,

      })
    };

    this.saveEvent.emit(data);

  }

  patchForm() {
    if (!this.field?.value) {
      return;
    }
    try {
      const value = JSON.parse(this.field.value);
      this.form.patchValue({
        road_type: value?.road_type ?? '',
        road_number: value?.road_number ?? null,
        road_lyric: value?.road_lyric ?? '',
        cruce_number: value?.cruce_number ?? null,
        cruce_lyric: value?.cruce_lyric ?? '',
        cruce_number_sub: value?.cruce_number_sub ?? null,
        cruce_lyric_sub: value?.cruce_lyric_sub ?? '',
        cruce_complement: value?.cruce_complement ?? '',
      });
    } catch (e) {
      this.customMessageService.responseNoticeHandler({ message: 'Valor de campo dirección inválido, no se pudo parsear JSON', error: e}, OriginMessageError.FRONTEND)
    }
  }



  get f() {
    return this.form.controls;
  }

}
